var _circle, _circle2, _path, _path2, _path3, _circle3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#314e55",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      fillRule: "evenodd"
    },
    transform: "translate(5 10)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 42,
    fill: "#f28544",
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 42,
    fill: "#f28544",
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.507991 11h9.492009l-2 22-39-4-2-18h10.75345",
    fill: "#d8d8d8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41 32.4939416v3.5704046h-37.7263053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42.9263446 12.9471388.6686034-5.9471388h7.0179287"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 11,
    fill: "#73c9c9",
    r: 11
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22 5v12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22 5v12",
    transform: "matrix(0 -1 1 0 11 33)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbt);
export default __webpack_public_path__ + "static/media/fbt.68c5fd5adeed9c7f7b6edda8ac216be9.svg";
export { ForwardRef as ReactComponent };